import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Header from "../components/layout/Header";
import Footer from "../components/layout/Footer";
import Hero from "../components/home/Hero";
import Marquee from "../components/home/Marquee";
import Problem from "../components/home/Problem";
import Journey from "../components/home/Journey";
import AISection from "../components/home/AISection";
import Trust from "../components/home/Trust";
import WhyIndia from "../components/home/WhyIndia";
import Corridors from "../components/home/Corridors";
import Specialties from "../components/home/Specialties";
import ForHospitals from "../components/home/ForHospitals";
import HospitalOS from "../components/home/HospitalOS";
import PatientExperience from "../components/home/PatientExperience";
import Vision from "../components/home/Vision";
import AboutTeaser from "../components/home/AboutTeaser";
import CurrentStage from "../components/home/CurrentStage";
import PartnerCTA from "../components/home/PartnerCTA";
import ContactBlock from "../components/ContactBlock";
import { Reveal, SectionHeading } from "../components/Reveal";
import { usePageMeta } from "../hooks/usePageMeta";
import { scrollToHash } from "../lib/api";

export default function HomePage() {
    const location = useLocation();
    const [interest, setInterest] = useState("");

    usePageMeta(
        "AI-Powered Medical Tourism & Cross-Border Healthcare | GoMedVoyage",
        "GoMedVoyage is building an AI-powered cross-border healthcare platform connecting international patients with trusted healthcare providers in India — one intelligent journey from diagnosis to recovery."
    );

    useEffect(() => {
        if (location.hash) {
            const t = setTimeout(() => scrollToHash(location.hash), 500);
            return () => clearTimeout(t);
        }
    }, [location.hash]);

    return (
        <div data-testid="home-page">
            <Header />
            <main>
                <Hero />
                <Marquee />
                <Problem />
                <Journey />
                <AISection />
                <Trust />
                <WhyIndia />
                <Corridors />
                <Specialties />
                <ForHospitals />
                <HospitalOS />
                <PatientExperience />
                <Vision />
                <AboutTeaser />
                <CurrentStage />
                <PartnerCTA />
                <section id="contact" data-testid="home-contact-section" className="py-28 lg:py-36 bg-tint-slate noise-overlay">
                    <div className="max-w-7xl mx-auto px-6 lg:px-8">
                        <Reveal>
                            <SectionHeading
                                chapter="15"
                                eyebrow="Contact"
                                title="Start a conversation."
                                description="Whether you are a patient exploring options, a hospital, an investor or a strategic partner — we'd love to hear from you."
                                testid="home-contact-heading"
                            />
                        </Reveal>
                        <div className="mt-16">
                            <ContactBlock selectedInterest={interest} onSelect={setInterest} testidPrefix="home-contact" />
                        </div>
                    </div>
                </section>
            </main>
            <Footer />
        </div>
    );
}
